import Highcharts from 'highcharts';
import { filterByCategory } from "../ranking-sm/data";

export function getTowingData(normalized) {
    const categories = [
        'Holowanie: nie-wraki łącznie',
        'Holowanie: wraki',
        'Mandaty: liczba wystawionych dot. PRD',
        'Liczba mieszkańców',
        'Holowanie: utrudnianie ruchu',
        'Holowanie: stwarzanie zagrożenia',
        'Holowanie: niepełnosprawni',
        'Holowanie: T-24',
        'Holowanie: DMC'
    ];
    const data = filterByCategory(categories);

    data.forEach(sm => {
        const divider = normalized ? sm['Liczba mieszkańców'] / 100000 : 1
        const totalTows = (sm['Holowanie: nie-wraki łącznie'] || 0) / divider

        const t24 = Math.round((sm['Holowanie: T-24'] || 0) / divider)
        const disabled = Math.round((sm['Holowanie: niepełnosprawni'] || 0) / divider)
        const obstruction = Math.round((sm['Holowanie: utrudnianie ruchu'] || 0) / divider)
        const security = Math.round((sm['Holowanie: stwarzanie zagrożenia'] || 0) / divider)
        const dmc = Math.round((sm['Holowanie: DMC'] || 0) / divider)
        const other = Math.round(Math.max(0, totalTows - (t24 + disabled + obstruction + dmc + security)))
        const wreck = Math.round((sm['Holowanie: wraki'] || 0) / divider)

        sm.towingReasons = { t24, disabled, obstruction, security, dmc, other, wreck };
        sm.totalTows = totalTows + wreck
    });

    return data;
}

export function chartTowing100k(id) {
    __chartTowing(id, 'Towing per 100k residents', true)
}

export function chartTowing(id) {
    __chartTowing(id, 'Number of towed vehicles', false)
}

function __chartTowing(id, title, normalized) {
    if (!document.getElementById(id)) return;

    const cityData = getTowingData(normalized).sort((a, b) => b.totalTows - a.totalTows);
    const categories = cityData.map(item => item.city);

    const t24Series = cityData.map(item => item.towingReasons.t24);
    const disabledSeries = cityData.map(item => item.towingReasons.disabled);
    const obstructionSeries = cityData.map(item => item.towingReasons.obstruction);
    const securitySeries = cityData.map(item => item.towingReasons.security);
    const dmcSeries = cityData.map(item => item.towingReasons.dmc);
    const otherSeries = cityData.map(item => item.towingReasons.other);
    const wreckSeries = cityData.map(item => item.towingReasons.wreck);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: title },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: title },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: (
                        Highcharts.defaultOptions.title.style &&
                        Highcharts.defaultOptions.title.style.color
                    ) || 'gray'
                }
            }
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: { enabled: false }
            }
        },
        legend: { enabled: true, verticalAlign: 'top', reversed: true },
        credits: { enabled: false },
        series: [{
            name: 'No data',
            data: otherSeries,
            color: '#bdc3c7'
        }, {
            name: 'Overweight (DMC)',
            data: dmcSeries,
            color: '#9b59b6'
        }, {
            name: 'Traffic obstruction',
            data: obstructionSeries,
            color: '#026900'
        }, {
            name: 'Hazard',
            data: securitySeries,
            color: '#e74c3c'
        }, {
            name: 'Disabled spot',
            data: disabledSeries,
            color: '#3498db'
        }, {
            name: 'T-24 sign',
            data: t24Series,
            color: '#f1c40f'
        }, {
            name: 'Wrecks',
            data: wreckSeries,
            color: '#000000'
        }]
    });
}
